import { takeLatest, take, put, call } from 'redux-saga/effects';

// actions
import { changePassword, setAPIInProgress } from 'store/actions/authActions';
import Api from 'api/auth';

export function* ensureChangePassword({ payload }) {
  const { resolve, reject, ...rest } = payload;
  try {
    yield put({ type: setAPIInProgress.type, payload: true });
    const { data } = yield call(Api.saveNewPassword, { data: JSON.stringify(rest) });
    yield put({ type: changePassword.success, payload: data });
    yield put({ type: setAPIInProgress.type, payload: false });
    if (resolve) {
      resolve(data);
    }
  } catch (err) {
    yield put({ type: setAPIInProgress.type, payload: false });
    yield put({
      type: changePassword.failure,
      err,
    });
    if (reject) {
      reject(err);
    }
  }
}

export function* watchPasswordChanges() {
  yield takeLatest(changePassword.type, ensureChangePassword);
  yield take(changePassword.success);
}
